import { Box, Container, Stack, Text, Title } from '@mantine/core';

import { PricingGrid } from '@/components/pricing/PricingGrid';
import { Reveal } from '@/components/motion/Reveal';

export function PricingPreview() {
  return (
    <Box component="section" id="pricing" py={{ base: 64, md: 96 }} aria-labelledby="pricing-title">
      <Container size="xl">
        <Stack align="center" ta="center" gap="md" mb={48}>
          <Reveal>
            <Text size="sm" tt="uppercase" lts="0.12em" c="var(--tf-forge-start)" fw={700}>
              Pricing
            </Text>
          </Reveal>
          <Reveal delay={0.05}>
            <Title id="pricing-title" order={2} style={{ fontSize: 'clamp(1.75rem, 3.5vw, 2.5rem)', letterSpacing: '-0.02em' }}>
              Free for tuning your car. Paid for the AI advisor.
            </Title>
          </Reveal>
          <Reveal delay={0.1}>
            <Text c="var(--tf-text-secondary)" maw={600}>
              No tiered crippling. The full map editor and deterministic safety engine are free.
              Pro unlocks the AI layer and the analyzer cloud sync.
            </Text>
          </Reveal>
        </Stack>

        <Reveal delay={0.15}>
          <PricingGrid />
        </Reveal>
      </Container>
    </Box>
  );
}
